import React, { FC, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ResultsTableRowData, SettingsAction, SettingsListTab, SettingsParams, SettingsType } from "../pages/types";
import SettingsList from "./settingsList";
import { useUserContext } from "../../../../context/userContextProvider";
import { Role } from "../../../../models";
import Box from "@material-ui/core/Box/Box";
import SettingsLogViewer from "./settingsLogViewer";
import SettingsTitle from "./settingsTitle";

type Props = {
  extraListElement?: JSX.Element;
  headers: string[];
  rows: ResultsTableRowData[] | null;
  sortColumn: number | null;
  titleSingle: string;
  titlePlural: string;
  type: SettingsType;
};

const entityNameMapping = {
  [SettingsType.classifications]: "classification",
  [SettingsType.clients]: "client",
  [SettingsType.emailaccounts]: "emailaccount",
  [SettingsType.groups]: "group",
  [SettingsType.grouprules]: "grouprule",
  [SettingsType.teams]: "team",
  [SettingsType.transferForms]: "actionextracttransferformdata",
  [SettingsType.systemAccounts]: "incomingemailaccountrule",
  [SettingsType.users]: "user",
  [SettingsType.extractAccountData]: "actionextractaccountdata",
}

const SettingsView: FC<Props> = ({ headers, rows, sortColumn, titleSingle, titlePlural, type, children, extraListElement }) => {
  const [activeTab, setActiveTab] = useState<SettingsListTab>(SettingsListTab.list);
  const { state :{ user: loggedInUser }} = useUserContext();
  const canViewHistory = Boolean(loggedInUser?.roles.includes(Role.SystemAdmin));
  const showHistory = canViewHistory && activeTab === SettingsListTab.history;
  const { action }: SettingsParams = useParams();
  return (
    <>
      {action === SettingsAction.list && rows && (
        <>
      <SettingsTitle title={`${titlePlural} ${activeTab === SettingsListTab.history ? "History" : "List"}`}>
        {type !== SettingsType.transferForms && (
          <div className="settings-actions">
            <Link to={`${type}/create`} className="btn btn-primary mb-3 float-right">
              {`Add New ${titleSingle}`}
            </Link>
          </div>
        )}
      </SettingsTitle>
      {canViewHistory && (
        <Box mt={3}>
          <ul className="tabs">
            <li>
              <button
                className={activeTab === SettingsListTab.list ? "active" : ""}
                onClick={() => setActiveTab(SettingsListTab.list)}
                type="button"
              >
                List
              </button>
            </li>
            <li>
              <button
                className={activeTab === SettingsListTab.history ? "active" : ""}
                onClick={() => setActiveTab(SettingsListTab.history)}
                type="button"
              >
                History
              </button>
            </li>
          </ul>
        </Box>
      )}
          {showHistory ? (
            <Box mt={3}>
              <SettingsLogViewer entityName={entityNameMapping[type]} />
            </Box>
          ) : (
            <>
              <SettingsList
                headers={headers}
                rows={rows}
                sortColumn={sortColumn}
                titlePlural={titlePlural}
              />
              {extraListElement && extraListElement}
        </>
      )}
      </>
      )}
      {(action === SettingsAction.create || action === SettingsAction.edit || action === SettingsAction.delete) 
        && <>{children}</>
      }
    </>
  );
};
export default SettingsView;
